module.exports = __webpack_public_path__ + "static/media/01_Timeline_edifice.505794ae.webp";